import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[validDomain]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ValidateDomainDirective, multi: true }],
    standalone: false,
})
export class ValidateDomainDirective implements Validator {
    validate (control: AbstractControl): ValidationErrors | null {
        if (control.value === '') {
            return null;
        }

        try {
            const url = new URL(control.value);
            if (url.protocol !== 'http:' && url.protocol !== 'https:') {
                return { validDomain: true };
            }
            return null;
        } catch (err) {
            return { validDomain: true };
        }
    }
}
